import WsService from "../WsService";
import ReferralLink from "../../domain/Registration/ReferralLink";


const ENDPOINT_BASE = "/registrations/registration-referral/generate-referral-link";

export default class RegistrationReferralService {

    static getReferralUrl() {
        let endpoint = ENDPOINT_BASE;
        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new ReferralLink(response);
            },
            response => {
                return response;
            });
    }
}
